"use client";

import React, { useEffect } from "react";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { PageBanner } from "@/components/common/PageBanner";
import { createLookupObject } from "@/helper/helper";

interface AboutClientProps {
  cmsData?: any[];
}

const AboutClient: React.FC<AboutClientProps> = ({ cmsData }) => {
  const [CMSData, setCMSData] = React.useState<any>({});
  useEffect(() => {
    if (cmsData && cmsData?.length > 0) {
      setCMSData(createLookupObject(cmsData, "Name"));
    }
  }, [cmsData]);

  const stats = [
    { label: "Years in Business", value: "10+" },
    { label: "Products", value: "500+" },
    { label: "Happy Retailers", value: "1000+" },
    { label: "Shipping", value: "PAN India" },
  ];

  const categories = [
    { name: "Earrings", sub: "Silver · Gold", emoji: "💍" },
    {
      name: "Mangalsutra",
      sub: "Gold · Silver · AD · Black Bead",
      emoji: "💛",
    },
    { name: "Jewellery Sets", sub: "Bridal · AD · Long", emoji: "✨" },
    { name: "Chains", sub: "Ladies · Mens", emoji: "⛓️" },
    { name: "Bracelets", sub: "Gents · Ladies · Kids", emoji: "💎" },
    { name: "Bangles & Anklets", sub: "Kadli · Silver", emoji: "🔮" },
    { name: "Chain Pendant", sub: "All styles", emoji: "🪙" },
    { name: "Rings & Others", sub: "Gents · Ladies · Tikka", emoji: "🌟" },
  ];

  const values = [
    {
      emoji: "🏭",
      title: "Direct Manufacturing",
      desc: "We make every product in our factory — no outsourcing, no middlemen. You get the manufacturer price.",
    },
    {
      emoji: "💰",
      title: "Best Wholesale Prices",
      desc: "Factory-direct pricing with up to 15% additional wholesale discounts on large orders.",
    },
    {
      emoji: "📦",
      title: "Reliable Shipping",
      desc: "All orders dispatched within 1–3 business days with full tracking across India.",
    },
    {
      emoji: "⭐",
      title: "Verified & Trusted",
      desc: "Verified business profile on IndiaMart with genuine customer reviews you can check.",
    },
    {
      emoji: "🤝",
      title: "Seller-Friendly",
      desc: "We support Flipkart, Amazon, Meesho and Myntra sellers with suitable packaging and pricing.",
    },
    {
      emoji: "📱",
      title: "WhatsApp Support",
      desc: "Daily support from 9 AM – 8 PM. Talk to a real person, not a chatbot.",
    },
  ];

  return (
    <main className="min-h-screen bg-black">
      <Navbar />

      {/* PAGE HERO */}
      {CMSData?.["About - Section 1 : Banner"] ? (
        <section
          className="banner-section border-b border-border-1 pt-18 pb-14 px-4 md:px-14 relative overflow-hidden"
          dangerouslySetInnerHTML={{
            __html: CMSData?.["About - Section 1 : Banner"]?.Template,
          }}
        />
      ) : (
        <section className="banner-section border-b border-border-1 pt-18 pb-14 px-4 md:px-14 relative overflow-hidden">
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[120px] bg-gold-pool opacity-5 pointer-events-none" />
          <div className="flex items-center gap-3.5 text-[10px] font-semibold tracking-[0.28em] uppercase text-gold-core mb-4 before:h-px before:w-15 before:bg-gradient-to-r before:from-gold-dim before:to-transparent">
            Our Story
          </div>
          <h1 className="font-cormorant text-[clamp(36px,5vw,64px)] font-light text-text-1 leading-[1.1] mb-3">
            About <em className="italic gold-text-gradient">NakMan</em>{" "}
            Jewellery
          </h1>
          <p className="text-sm text-text-2 font-light leading-relaxed max-w-lg">
            A family business built on craftsmanship, trust, and the belief that
            every customer deserves factory-direct pricing.
          </p>
        </section>
      )}

      {/* WHO WE ARE */}
      {CMSData?.["About - Section 2 : Who We Are"] && (
        <section
          className="py-20 px-4 md:px-14 bg-black-2"
          dangerouslySetInnerHTML={{
            __html: CMSData?.["About - Section 2 : Who We Are"]?.Template,
          }}
        />
      )}
      {/* <section className="py-20 px-4 md:px-14 bg-black-2">
        <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-24">
          <div className="flex-1 space-y-7">
            <div className="text-[10px] font-semibold tracking-[0.28em] uppercase text-gold-core flex items-center gap-3.5">
              Who We Are
              <span className="h-px w-15 bg-gradient-to-r from-gold-dim to-transparent" />
            </div>
            <h2 className="font-cormorant text-4xl md:text-5xl font-normal text-text-1 leading-tight">
              Malabar Enterprise —{" "}
              <em className="italic gold-text-gradient">Direct from Factory</em>
            </h2>
            <div className="space-y-4 text-sm text-text-2 leading-[1.9] font-light">
              <p>
                Malabar Enterprise is a wholesale imitation jewellery
                manufacturer based in Ahmedabad, Gujarat — the heart of India's
                jewellery industry. Under our brand{" "}
                <strong className="text-text-1 font-medium">
                  NakMan Jewellery
                </strong>
                , we design, manufacture, and sell premium quality imitation
                jewellery directly to retailers and online sellers across India.
              </p>
              <p>
                By eliminating every middleman in the chain, we are able to
                offer you the lowest possible wholesale prices — factory-direct
                to your door. Our products are trusted by thousands of
                retailers, Flipkart sellers, Amazon sellers, Meesho sellers, and
                independent shop owners across the country.
              </p>
            </div>
            <a
              href="https://www.indiamart.com/malabarenterprise/"
              target="_blank"
              className="btn-gold inline-block"
            >
              Verify Us on IndiaMart
            </a>
          </div>

          <div className="grid grid-cols-2 gap-3 w-full lg:w-[480px]">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-black-3 border border-border-1 border-t-2 border-t-gold-dim p-6 flex flex-col justify-center text-center group hover:border-t-gold-core transition-all"
              >
                <div className="font-cormorant text-4xl font-bold gold-text-gradient leading-none">
                  {stat.value}
                </div>
                <div className="text-[11px] text-text-3 tracking-[0.1em] uppercase mt-1.5">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* PRODUCT RANGE */}
      {CMSData?.["About - Section 2 : Who We Are"] && (
        <section
          className="py-20 px-4 md:px-14 bg-black"
          dangerouslySetInnerHTML={{
            __html: CMSData?.["About - Section 3 : What We Offer"]?.Template,
          }}
        />
      )}
      {/* <section className="py-20 px-4 md:px-14 bg-black">
        <div className="text-gold-core text-[10px] font-semibold tracking-[0.28em] uppercase flex items-center gap-3.5 mb-4">
          What We Offer
          <span className="h-px w-15 bg-gradient-to-r from-gold-dim to-transparent" />
        </div>
        <h2 className="font-cormorant text-4xl md:text-5xl font-normal text-text-1 mb-10">
          Our <em className="italic gold-text-gradient">Product Range</em>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {categories.map((cat) => (
            <div
              key={cat.name}
              className="bg-black-2 border border-border-1 p-5 flex items-center gap-4 hover:bg-black-3 hover:border-gold-dim/50 transition-all cursor-default"
            >
              <span className="text-2xl filter drop-shadow-[0_0_5px_rgba(200,150,26,0.3)]">
                {cat.emoji}
              </span>
              <div>
                <div className="text-[13px] font-medium text-text-1">
                  {cat.name}
                </div>
                <div className="text-[11px] text-text-3 tracking-wide mt-0.5">
                  {cat.sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* WHY CHOOSE US */}
      {CMSData?.["About - Section 4 : Why Choose Us"] && (
        <section
          className="py-20 px-4 md:px-14 bg-black-2"
          dangerouslySetInnerHTML={{
            __html: CMSData?.["About - Section 4 : Why Choose Us"]?.Template,
          }}
        />
      )}
      {/* <section className="py-20 px-4 md:px-14 bg-black-2">
        <div className="text-gold-core text-[10px] font-semibold tracking-[0.28em] uppercase flex items-center gap-3.5 mb-4">
          Why Choose Us
          <span className="h-px w-15 bg-gradient-to-r from-gold-dim to-transparent" />
        </div>
        <h2 className="font-cormorant text-4xl md:text-5xl font-normal text-text-1 mb-14">
          The <em className="italic gold-text-gradient">NakMan</em> Promise
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {values.map((v) => (
            <div
              key={v.title}
              className="bg-black-3 border border-border-1 border-l-2 border-l-gold-dim p-6 lg:p-7 space-y-3 hover:bg-black hover:border-l-gold-core transition-colors group"
            >
              <div className="text-[20px] text-gold-core">{v.emoji || "✦"}</div>
              <h3 className="text-sm font-medium text-text-1 tracking-wide">
                {v.title}
              </h3>
              <p className="text-xs text-text-2 leading-relaxed font-light">
                {v.desc}
              </p>
            </div>
          ))}
        </div>
      </section> */}

      <div className="gold-divider" />
      <Footer />
    </main>
  );
};

export default AboutClient;
